{
  "title": "Documents",
  "subtitle": "Every receipt, invoice, credit note and Z report issued. Open one to read or print it.",
  "empty": {
    "title": "No document issued yet",
    "text": "Receipts, invoices, credit notes and Z reports show here as soon as they are issued."
  },
  "tabs": {
    "all": "All",
    "receipt": "Receipts",
    "invoice": "Invoices",
    "creditNote": "Credit notes",
    "zReport": "Z reports"
  },
  "list": {
    "search": "Number, order, customer, tax ID, phone or SKU",
    "filters": "Filters",
    "clear": "Clear filters",
    "register": "Register",
    "allRegisters": "All registers",
    "paymentMethod": "Payment method",
    "allPaymentMethods": "All payment methods",
    "issuedBy": "Issued by",
    "allPeople": "Issued by anyone",
    "taxId": "Buyer's tax ID",
    "anyTaxId": "With or without a tax ID",
    "taxIds": {
      "with": "With a tax ID",
      "without": "Without a tax ID"
    },
    "minTotal": "Amount from",
    "maxTotal": "Amount to",
    "noMatch": "No document matches these filters.",
    "showing_one": "{{first}}–{{last}} of {{total}} document",
    "showing_other": "{{first}}–{{last}} of {{total}} documents",
    "amount": "Total {{amount}}"
  },
  "columns": {
    "document": "Document",
    "date": "Date",
    "buyer": "Customer",
    "order": "Order",
    "site": "Site",
    "by": "Issued by",
    "total": "Total (TND)"
  },
  "types": {
    "receipt": "Receipt",
    "invoice": "Invoice",
    "creditNote": "Credit note",
    "zReport": "Z report"
  },
  "document": {
    "immutable": "Issued documents never change. Corrections are made with a credit note.",
    "print": "Print",
    "taxId": "Tax ID",
    "tradeRegister": "Trade register",
    "date": "Date",
    "order": "Order",
    "buyer": "Customer",
    "counterSale": "Counter sale",
    "corrects": "Corrects invoice",
    "reason": "Reason",
    "paymentMethod": "Payment method",
    "columns": {
      "ref": "Ref.",
      "item": "Description",
      "quantity": "Qty",
      "unitPrice": "Unit price excl. VAT",
      "discount": "Disc.",
      "vat": "VAT",
      "total": "Total excl. VAT"
    },
    "refundLine": "Refund",
    "vatRate": "VAT rate",
    "vatBase": "Base excl. VAT",
    "vatAmount": "VAT",
    "discounts": "Discount",
    "shipping": "Shipping",
    "net": "Total excl. VAT",
    "tax": "Total VAT",
    "total": "Total incl. VAT",
    "stampDuty": "Stamp duty",
    "totalDue": "Amount due",
    "totalCredit": "Amount credited",
    "amountsIn": "Amounts in Tunisian dinars (TND).",
    "issuedBy": "Issued by {{name}}.",
    "correctsReceipt": "Corrects receipt",
    "openOrder": "Order {{number}}",
    "onlyTheDate": "Only an invoice’s date can change. Any other correction is made with a credit note.",
    "changeDate": "Change the date",
    "dateTitle": "Date of {{number}}",
    "dateHint": "From {{from}} to {{to}}, so that dates follow the numbers.",
    "dateChanged": "Date changed",
    "title": {
      "receipt": "Till receipt",
      "invoice": "Invoice",
      "creditNote": "Credit note"
    },
    "number": "No.",
    "tel": "Tel.",
    "reference": "References",
    "customerCode": "Customer code",
    "orderDate": "Order date",
    "datedOn": "of {{date}}",
    "gross": "Gross total excl. VAT",
    "netAfter": "Net total excl. VAT",
    "inWords": {
      "invoice": "This invoice is closed at the sum of:",
      "creditNote": "This credit note is closed at the sum of:",
      "receipt": "This receipt is closed at the sum of:"
    },
    "stamp": "Stamp and signature",
    "bank": "Bank",
    "rib": "RIB",
    "colon": ": "
  },
  "print": {
    "title": "Print options",
    "subtitle": "Set in Configuration. Changes here are for this print only.",
    "reset": "Back to the defaults",
    "print": "Print",
    "kinds": {
      "invoice": "Invoices and credit notes",
      "deliveryNote": "Delivery notes"
    },
    "parts": {
      "company": "Company",
      "references": "References",
      "customer": "Customer",
      "table": "Table",
      "totals": "Totals",
      "foot": "Foot of the page"
    },
    "options": {
      "logo": "Logo",
      "tradeName": "Trade name",
      "contact": "Phone and email",
      "sellerTaxId": "Tax ID",
      "tradeRegister": "Trade register",
      "customerCode": "Customer code",
      "orderNumber": "Order number",
      "orderDate": "Order date",
      "paymentMethod": "Payment method",
      "deliveryBox": "Whole Delivery box",
      "deliveryMode": "Delivery mode",
      "carrier": "Carrier",
      "tracking": "Tracking number",
      "buyerContact": "Customer’s phone and email",
      "buyerPhone": "Customer’s phone",
      "buyerTaxId": "Customer’s tax ID",
      "refColumn": "Ref. column",
      "unitPriceColumn": "Unit price column",
      "discountColumn": "Discount column",
      "vatColumn": "VAT column",
      "promotions": "Promotion names",
      "remarks": "Order remarks",
      "discountDetail": "Gross total and discount",
      "amountInWords": "Amount in words",
      "signature": "Stamp and signature box",
      "senderSignature": "Sender’s stamp and signature",
      "receiverSignature": "Receiver’s signature",
      "amountsNote": "Currency note",
      "issuedBy": "Who issued it",
      "legalFooter": "Company details at the foot",
      "bankDetails": "Bank and RIB"
    }
  }
}
